const QUERIES = {
  USERS_LIST: 'users-list',
  SUBSCRIPTION_PLAN:'subscription_plan'
}

export {QUERIES}
